import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { redirectToLogin } from "../utils/auth";
import { Loading } from "../Components/Loading/Loading";
import { useUser } from "../context/UserContext";
import { getLoaStatusLabel, LOA_STATUS_BADGE_CLASSES } from "../constants/loaStatus";

export const LoaList = () => {
  const [loas, setLoas] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useUser();
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (!authToken) {
      redirectToLogin();
      return;
    }
    if (!user.loaded) return;

    const BASE = process.env.REACT_APP_BACKEND_URL;
    fetch(`${BASE}/API/V2/LOA`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((r) => {
        if (r.status === 401) {
          redirectToLogin();
          return null;
        }
        return r.json();
      })
      .then((data) => {
        if (!data) return;
        if (data.error) {
          alert(data.error);
          return;
        }
        setLoas(data);
        setDataLoading(false);
      })
      .catch((err) => console.error("LOA list load error:", err));
  }, [user.loaded]);

  if (dataLoading || !user.loaded) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col p-6 min-h-[calc(100vh-72px)]">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-bold">LOA Management</h2>
        <button
          className="text-xs rounded-3xl px-4 py-2 font-bold tracking-tight leading-tight text-white bg-jiojbm50 hover:bg-jiojbm60"
          onClick={() => navigate("/LOA/new")}
        >
          + Upload New LOA
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.05)] overflow-hidden">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-gray-50">
              <th className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200">Upload ID</th>
              <th className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200">Organization</th>
              <th className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200">Submission Date</th>
              <th className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200">Assistants</th>
              <th className="p-4 text-xs uppercase text-gray-500 border-b border-gray-200">State</th>
            </tr>
          </thead>
          <tbody>
            {loas.length === 0 && (
              <tr>
                <td className="p-4 text-sm text-gray-500" colSpan={5}>
                  No LOAs found.
                </td>
              </tr>
            )}
            {loas.map((loa) => (
              <tr
                key={loa.loaId}
                className="cursor-pointer border-t hover:bg-gray-50"
                onClick={() => navigate(`/LOA/${loa.loaId}`)}
              >
                <td className="p-4 text-sm font-bold text-jiojbm50">{loa.loaId}</td>
                <td className="p-4 text-sm">{loa.org}</td>
                <td className="p-4 text-sm">
                  {new Date(loa.createdAt).toLocaleDateString()}
                </td>
                <td className="p-4 text-sm">
                  {loa.assistants?.length ?? 0} Assistant{loa.assistants?.length === 1 ? "" : "s"}
                </td>
                <td className="p-4 text-sm">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${LOA_STATUS_BADGE_CLASSES[loa.status] ?? "bg-gray-200 text-gray-700"}`}
                  >
                    {getLoaStatusLabel(loa.status)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
